// #region Dependencias
import { Timestamp, collection, doc, setDoc } from 'firebase/firestore'
import { db } from 'services/firebase'
import { finishLoading, setDialogoAbierto, startLoading } from 'store/slices/uiSlice'
import { responseMessageHandler } from 'utils/responseMessageHandler'
// #endregion

/**
 * Thunk que registra el correo electrónico de un nuevo cliente asociándolo a una pagina.
 *
 * @param {string} correo - Correo electrónico del cliente.
 *
 * @return {Function} Función que envía las acciones asíncronas al store de Redux.
 */
export const createClientRequest = (clienteDato, idioma, t) => async (dispatch, getState) => {
  dispatch(startLoading())

  // Obtener pagina seleccionada actualmente
  const { paginaSeleccionada } = getState().pages

  const clientesRef = doc(collection(db, 'clientes'))

  // Crear objeto de cliente con su respectivo correo y ID de pagina asociada
  const cliente = {
    id: clientesRef.id,
    nombre: clienteDato.nombre.trim(),
    telefono: clienteDato.telefono.trim(),
    correo: clienteDato.correo.trim(),
    fecha: Timestamp.fromDate(new Date()),
    idioma,
    paginaId: paginaSeleccionada.id
  }

  setDoc(clientesRef, cliente)
    .then(() => {
      dispatch(
        setDialogoAbierto({
          abierto: true,
          tipo: 'success',
          titulo: t('pages.register-success'),
          mensaje: t('pages.email-registered')
        })
      )
    })
    .catch((err) => responseMessageHandler(err, dispatch))
    .finally(() => dispatch(finishLoading()))
}
